import { Component, OnInit } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { CustomerFairShareRowModel } from '../../../../models/customer-points-row.model';
import { IndicatorBoxModel } from '../../../../models/indicator-box.model';
import { LoyaltyChart } from '../../../../models/loyalty-chart-config.model';
import { QFilterModel } from '../../../../models/qfilter.model';
import { AnalyticsService } from '../../../../services/analytics/analytics.service';
import { CustomerCampaignService } from '../../../../services/customer/customer-campaign.service';
import { IndicatorsChartService, IndicatorsService } from '../../../../services/indicators/indicators.service';

@Component({
  selector: 'app-customer-fair-share',
  templateUrl: './customer-fair-share.component.html',
  styleUrls: ['./customer-fair-share.component.css']
})
export class CustomerFairShareComponent implements OnInit {

  public indicators: IndicatorBoxModel[] = [];

  translations: any;
  datatable: Array<CustomerFairShareRowModel>;

  public data: QFilterModel;
  private clusterList: any;

  constructor(
    private indicatorService: IndicatorsService,
    private chartsService: IndicatorsChartService,
    private svcAnalytics: AnalyticsService,
    private srvCustomerCampaign: CustomerCampaignService,
    private translate: TranslateService
  ) { }

  ngOnInit() {
    this.translate.get([
      'indicator.descrizione_categoria',
      'indicator.revenues_sel',
      'indicator.inc_sel_su_card',
      'indicator.battuta_media_sel',
      'indicator.battuta_media_card',
      'indicator.delta_battuta_media',
      'indicator.prc_speso_categ_selezionati',
      'indicator.prc_speso_categ_cardisti',
      'indicator.delta_prc_speso',
      'indicator.tot_cardisti',
      'indicator.euro_tot_cardisti'
    ]).subscribe((t) => {
      this.translations = {
        descrizione_categoria: t['indicator.descrizione_categoria'],
        revenues_sel: t['indicator.revenues_sel'],
        inc_sel_su_card: t['indicator.inc_sel_su_card'],
        battuta_media_sel: t['indicator.battuta_media_sel'],
        battuta_media_card: t['indicator.battuta_media_card'],
        delta_battuta_media: t['indicator.delta_battuta_media'],
        prc_speso_categ_selezionati: t['indicator.prc_speso_categ_selezionati'],
        prc_speso_categ_cardisti: t['indicator.prc_speso_categ_cardisti'],
        delta_prc_speso: t['indicator.delta_prc_speso'],
        tot_cardisti: t['indicator.tot_cardisti'],
        euro_tot_cardisti: t['indicator.euro_tot_cardisti']
      };
    });
  }

  setChartInstance(chart: LoyaltyChart, chartInstance) {
    chart.instance = chartInstance;
  }

  searchValueTrend(data: QFilterModel) {
    this.data = data;

    this.translate.get([
      'indicator.vend_valore_sel',
      'indicator.vend_volume_sel',
      'indicator.battuta_media_selezionati',
      'indicator.num_clienti_selezionati',
    ]).subscribe(t => {
      this.indicators = [];

      this.indicatorService.indicatorCalculation('customers.Q065', this.data).switchMap((res) => {
        const i = new IndicatorBoxModel([res[0], res[1]], {dynamic: true, hide_prev_value: true}, t);
        i.penetration.unitOfMeasure = this.translations.tot_cardisti; // '% dei tot cardisti';
        this.indicators.push(i);


        return this.indicatorService.indicatorCalculation('customers.Q066', this.data);
      }).subscribe((res) => {

        console.log('Q066', res);

        const vend_valore_sel = [
          res.find(ind => ind.name === 'vend_valore_sel'),
          res.find(ind => ind.name === 'vend_valore_sel_pct')
        ];

        const vend_volume_sel = [
          res.find(ind => ind.name === 'vend_volume_sel'),
          res.find(ind => ind.name === 'vend_volume_sel_pct')
        ];

        const battuta_media_selezionati = [
          res.find(ind => ind.name === 'battuta_media_selezionati'),
          res.find(ind => ind.name === 'battuta_media_tot_card')
        ];
        const valore = new IndicatorBoxModel(vend_valore_sel, {dynamic: true, hide_prev_value: true}, t);
        valore.penetration.unitOfMeasure = this.translations.tot_cardisti;   // '% dei tot cardisti';
        const volume = new IndicatorBoxModel(vend_volume_sel, {dynamic: true, hide_prev_value: true}, t);
        volume.penetration.unitOfMeasure = this.translations.tot_cardisti;   // '% dei tot cardisti';
        const battuta = new IndicatorBoxModel(battuta_media_selezionati, {hide_prev_value: true}, t);
        battuta.penetration.unitOfMeasure = this.translations.euro_tot_cardisti;  // '€ tot cardisti';

        this.indicators.push(valore);
        this.indicators.push(volume);
        this.indicators.push(battuta);

        // this.indicators.forEach((i) => i.penetration.unitOfMeasure = '% dei tot cardisti');
      });
    });

    this.indicatorService.getFairShareTable('customers.Q069', this.data).subscribe((resp) => {
      this.datatable = resp.slice(0, resp.length - 1);
    });
  }

  public setClusterList(clusterList: any){
    this.clusterList = clusterList;
  }

  public clustersString() {
    const nice = [];

    if (this.data && this.data.clusters && this.clusterList) {
      this.data.clusters.forEach(clusterCode => {
        nice.push(this.clusterList.find(cluster => cluster.code === clusterCode).description);
      });
    } else {
      return 'ALL';
    }

    return nice.join(', ');
  }

  resetData() {
    this.data = null;
    this.indicators = [];
  }

}



// WEBPACK FOOTER //
// ./src/app/views/customerDB/customer-value/customer-fair-share/customer-fair-share.component.ts